import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_el_sub_menu = _resolveComponent("el-sub-menu");
  const _component_el_menu = _resolveComponent("el-menu");
  const _component_el_row = _resolveComponent("el-row");
  return _openBlock(), _createBlock(_component_el_row, {
    justify: "start"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_menu, {
      class: "header-menu",
      mode: "horizontal",
      "default-active": _ctx.state.defaultActive,
      ellipsis: false
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu.navs, nav => {
        return _openBlock(), _createElementBlock(_Fragment, null, [nav.children && nav.children.length !== 0 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
          index: nav.path,
          key: nav.path
        }, {
          title: _withCtx(() => {
            var _nav$meta;
            return [_createTextVNode(_toDisplayString((_nav$meta = nav.meta) === null || _nav$meta === void 0 ? void 0 : _nav$meta.title), 1)];
          }),
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nav.children, sub => {
            return _openBlock(), _createElementBlock(_Fragment, null, [sub.children && sub.children.length !== 0 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
              index: sub.path,
              key: sub.path
            }, {
              title: _withCtx(() => {
                var _sub$meta;
                return [_createTextVNode(_toDisplayString((_sub$meta = sub.meta) === null || _sub$meta === void 0 ? void 0 : _sub$meta.title), 1)];
              }),
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sub.children, ssub => {
                return _openBlock(), _createBlock(_component_el_menu_item, {
                  index: ssub.path,
                  key: ssub.path,
                  onClick: $event => _ctx.onClickMenu(ssub)
                }, {
                  default: _withCtx(() => {
                    var _ssub$meta;
                    return [_createTextVNode(_toDisplayString((_ssub$meta = ssub.meta) === null || _ssub$meta === void 0 ? void 0 : _ssub$meta.title), 1)];
                  }),
                  _: 2
                }, 1032, ["index", "onClick"]);
              }), 128))]),
              _: 2
            }, 1032, ["index"])) : (_openBlock(), _createBlock(_component_el_menu_item, {
              index: sub.path,
              key: sub.path + 1,
              onClick: $event => _ctx.onClickMenu(sub)
            }, {
              default: _withCtx(() => {
                var _sub$meta2;
                return [_createTextVNode(_toDisplayString((_sub$meta2 = sub.meta) === null || _sub$meta2 === void 0 ? void 0 : _sub$meta2.title), 1)];
              }),
              _: 2
            }, 1032, ["index", "onClick"]))], 64);
          }), 256))]),
          _: 2
        }, 1032, ["index"])) : (_openBlock(), _createBlock(_component_el_menu_item, {
          index: nav.path,
          key: nav.path + 1,
          onClick: $event => _ctx.onClickMenu(nav)
        }, {
          default: _withCtx(() => {
            var _nav$meta2;
            return [_createTextVNode(_toDisplayString((_nav$meta2 = nav.meta) === null || _nav$meta2 === void 0 ? void 0 : _nav$meta2.title), 1)];
          }),
          _: 2
        }, 1032, ["index", "onClick"]))], 64);
      }), 256))]),
      _: 1
    }, 8, ["default-active"])]),
    _: 1
  });
}